<app-header></app-header>
<app-sidebar></app-sidebar>

<main class="full-wrap">
  <div class="main-div">
    <iframe id="fp_embed_player" [src]="liveUrl" marginwidth="0" marginheight="0" frameborder="0" width="100%"
      height="100%" class="vero" style="min-height: 600px !important;" allowfullscreen="allowfullscreen">
    </iframe>
  </div>
</main>